// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5Obwq","box":"styles_box__VZ7af","image":"styles_image__g1ESx","btnReadMore":"styles_btnReadMore__vSAMN","date":"styles_date__SCOo1"};